import { render, staticRenderFns } from "./ClassificationImageManagement.vue?vue&type=template&id=b622ba02"
import script from "./ClassificationImageManagement.vue?vue&type=script&lang=ts"
export * from "./ClassificationImageManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports